<template>
  <v-card
    class="py-2 max-shadow"
  >
    <v-list-tile>
      <v-list-tile-content>
        <v-list-tile-title class="d-flex justify-space between">
          <span class="headline blue-grey--text text--darken-3">
            {{ value }}
          </span>
        </v-list-tile-title>
        <v-list-tile-sub-title>
          <span class="caption font-weight-bold blue-grey--text text--darken-3">
            {{ titleUppercase }}
          </span>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-layout
        row
        fill-height
        align-start
        justify-end
        v-if="refresh"
      >
        <v-icon
          class="pr-3"
          :color="color"
          @click="$emit('refresh', title)"
        >
          refresh
        </v-icon>
      </v-layout>
      <v-divider vertical />
      <v-list-tile-avatar>
        <v-icon
          :color="color"
          x-large
          class="pa-1"
        >
          {{ icon }}
        </v-icon>
      </v-list-tile-avatar>
    </v-list-tile>
  </v-card>
</template>
<script>
export default {
  name: 'CountWidget',
  props: {
    color: {
      type: String,
      default: 'primary',
      required: true
    },
    icon: {
      type: String,
      default: 'home',
      required: false
    },
    title: {
      type: String,
      default: '',
      required: true
    },
    value: {
      type: Number,
      default: 0,
      required: true
    },
    refresh: {
      type: Boolean,
      default: true,
      require: false
    }
  },
  data() {
    return {};
  },
  computed: {
    titleUppercase() {
      return this.title.toUpperCase();
    }
  }
};
</script>

